export default class OfferMainDescription {
  constructor($scope, $rootScope, OfferService, UserService) {
    $scope.load_user_notes = function() {
      if ($scope.offer.supplier_id) {
        UserService.get_notes($scope.offer.supplier_id).then(function(data) {
          $scope.offer.notes = data.notes;
        });
      } else {
        alert('Please select a supplier first!');
      }
    };

    $scope.set_description_data = function() {
      var count = 0;
      if ($scope.offer.subtitleEN)
        count++;
      if ($scope.offer.full_description)
        count++;
      if ($scope.offer.notes)
        count++;
      var percentage = Math.floor(count / 3 * 100.0);
      $rootScope.$broadcast('set_sidebar_data', [1, 2, [{
        type: 'percentage',
        value: percentage
      }, null]]);
    };

    $scope.update_offer = function() {
      $scope.updating = true;
      $scope.form_error = '';
      OfferService.save($scope.offer).then(function(data) {
        if (!data.success)
          $scope.form_error = data.message;
        else
          $scope.set_description_data();
        $scope.updating = false;
      });
    };

    $scope.init = function() {
      $scope.offer = window.offer;
    };

    $scope.init();
  }
}

OfferMainDescription.$inject = ['$scope', '$rootScope', 'OfferService', 'UserService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-main-description.ctrl.js